'use client';

import Link from 'next/link';

import { useLocale } from '@hooks/useLocale';
import { cn } from '@utils/cn';
import { getLocaleStoryUrl } from '@utils/getTranslatedStory';
import { type ButtonStoryblok } from '@utils/storyblok/storyblok';
import { storyblokEditable } from '@utils/storyblok/storyblokEditable';
import { buttonVariants } from '@common/interaction/Button';

export function Button(props: ButtonStoryblok) {
  const { locale, localePrefix } = useLocale();
  const { link, label, size, variant, color } = props;

  if (!link) return null;

  if (link?.linktype === 'url' && link?.url) {
    return (
      <Link
        {...storyblokEditable(props)}
        className={cn(
          buttonVariants({
            variant: variant || 'contained',
            color: color || 'primary',
            size: size || 'lg',
          }),
        )}
        href={link.url}
        target={link?.target || '_self'}
      >
        {label}
      </Link>
    );
  }

  return (
    <Link
      {...storyblokEditable(props)}
      className={cn(
        buttonVariants({
          variant: variant || 'contained',
          color: color || 'primary',
          size: size || 'lg',
        }),
      )}
      href={getLocaleStoryUrl(link.story, locale, localePrefix) || '/'}
      target={link?.target || '_self'}
    >
      {label}
    </Link>
  );
}
